@if (isFormLoading) {
  <div class="spinner-container">
    <app-loading-spinner></app-loading-spinner>
  </div>
}

<div class="edit-page-background"></div>
<div class="edit-page-content">
  <app-spo-detail-page-header [spoDetails]="spoDetails"></app-spo-detail-page-header>
  <app-spo-detail-form (updatedSpo)="updateSpoHeaderValues($event)"
    [isEdit]="true"
    [spoDetails]="spoHeader"
    [spoStatus]="spoDetails.status.code"
    [spoMaterials]="spoMaterials"
  (formIsLoading)="manageFormLoading($event)"></app-spo-detail-form>
  <div class="spo-edit-section-material">
    <app-material-list [materials]="spoMaterials"
      [maxNumberOfMaterials]="maxNumberOfMaterials"
      (materialToUpdate)="addMaterialToUpdate($event)"
      [supplyingPackingPlantCode]="$safeNavigationMigration(spoDetails.supplyingPackingPlant?.code)"
      (undoMaterialToUpdate)="undoMaterialToUpdate($event)"
      [showBtnAdd]="!isSpoOpen"
      [showExtraColumns]="isSpoOpen"
      [showCtxMenu]="true"
      [showTooltipWarnings]="true"
      [refreshMaterialListOnDelete]="false"
    [transportDocumentType]="$safeNavigationMigration(spoDetails.transportMode?.transportDocumentType)"></app-material-list>
  </div>
</div>
<div class="edit-page-footer" data-cy="edit-page-footer">
  <button type="button" class="btn-text-link" (click)="cancelClick()" data-cy="spo-edit-cancel-button">
    <span class="text">Cancel</span>
  </button>
  <button type="button" class="btn-primary" (click)="saveClick()" [disabled]="isDisabled()"
    data-cy="spo-edit-save-button">Save
  </button>
</div>
